import React from "react";
import { object, string } from "prop-types";
import HeroBrand from "../../../../../ui/HeroBrand";

const SectionHero = ({ brandCode, heroConfig, ...props }) => {
	return <HeroBrand brandCode={brandCode} config={heroConfig} {...props} />;
};

SectionHero.propTypes = {
	brandCode: string,
	heroConfig: object, // eslint-disable-line react/forbid-prop-types
};

export default SectionHero;
